import styled, { css } from 'styled-components';
import React, { FC, InputHTMLAttributes } from 'react';

const ChevronDownIcon = (props: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 5.5L7.78261 10.5L3 5.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const FormItemWrapper = styled.div``;

const InputWrapper = styled.label<{ disabled?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--color-grey-700);
    `}
`;

const InputLabel = styled.span`
  font-size: 0.75rem;
  line-height: 1;
  font-weight: bold;
`;

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 3rem;
`;

export const StyledSelect = styled.select<{ error?: boolean }>`
  padding: 0.75rem 3rem 0.75rem 1rem;
  border: 1px solid var(--color-text-default);
  border-radius: 2px;
  appearance: none;
  caret-color: var(--color-primary);
  font-size: 1rem;
  line-height: 1;
  background: rgba(26, 26, 26, 0.4);
  backdrop-filter: blur(0.25rem);
  height: 3rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-overflow: ellipsis;

  :focus {
    border-color: var(--color-primary);
  }

  :disabled {
    border-color: var(--color-grey-700);
  }

  ${({ error }) =>
    error &&
    css`
      border-color: var(--color-signal-red);
    `}
`;

const SelectIcon = styled(ChevronDownIcon)`
  position: absolute;
  width: 1rem;
  height: 1rem;
  bottom: 1.5rem;
  transform: translateY(50%);
  right: 1rem;
  line-height: 1;
  pointer-events: none;
`;

interface InputProps extends InputHTMLAttributes<HTMLSelectElement> {
  name: string;
  label?: string;
  error?: string | { [type: string]: string };
  items: any[];
  selected?: any;
}

export const FanseaDropdown: FC<InputProps> = (props) => {
  const { className, label, name, type, items, error, ...inputProps } = props;

  return (
    <FormItemWrapper>
      <InputWrapper className={className}>
        {label && <InputLabel>{label}</InputLabel>}
        <SelectWrapper>
          <StyledSelect {...inputProps}>
            {items.map(({ value, name }, index) => (
              <option key={index} value={value}>
                {name}
              </option>
            ))}
          </StyledSelect>
        </SelectWrapper>
        <SelectIcon />
      </InputWrapper>
    </FormItemWrapper>
  );
};
